var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { TreeNavItem, Button, useModal } from "@animech/ui";
import * as Styled from "./sidebar.style";
import { GripPositionMenu, TubeConnectionMenu, CentralizedVacuumPumpMenu, ApplicationSpeedMenu, EdgeMenu, FeedPressurePointMenu, } from "./tree-nav-menus";
import { MixedSelectionMenu } from "./tree-nav-menus/mixed-selection-menu";
import { DefaultGroupMenu } from "./tree-nav-menus/default-group-menu";
import { ApplicationMenu } from "./tree-nav-menus/application-menu";
import { usePlaycanvasApplicationContext } from "providers/playcanvas-application";
import { Logo } from "ui/components/elements/logo";
import { CustomTreeNav } from "ui/components/elements/custom-treenav";
import { TimedNotification } from "ui/components/elements/timed-notification";
import { DelayedFallback } from "ui/utility/delayed-fallback";
import { LoadingOverlay } from "ui/components/elements/loading-overlay";
import { SummaryModal } from "ui/components/modals/summary";
import { Toolbar } from "ui/components/elements/toolbar";
import { useAppSelector, useAppDispatch, selectors, actions } from "store";
import { MenuItem, NodeComponentType } from "store/types";
import { getSharableLink } from "utility/share";
import { useGraphDataContext } from "providers/graph-panel";
import { TitleWithInfoButton } from "ui/components/panels/sidebar/title-with-info-button";
import { SidebarDrawerButton } from "ui/components/elements/custom-drawer";
import { DeveloperTicket } from "ui/components/elements/ticket/developer-ticket";
import { SystemTypeSwitch } from "ui/components/panels/sidebar/system-type-switch";
import { persistConfigs } from "store/persist";
import { GoogleAnalyticsElement } from "ui/components/elements/ga-element/ga-element";
import { contactFormURL } from "authentication/constants";
import { LocalStorage } from "utility";
import { StorageKey } from "utility/session-storage/constants";
import { googleAnalyticsEvents, loadConfigurationParameterName, } from "utility/constants";
export var SidebarPanel = function () {
    var _a;
    var _b = __read(useState(false), 2), showShareNotification = _b[0], setShowShareNotification = _b[1];
    var _c = __read(useState(false), 2), showShareFailedNotification = _c[0], setShowShareFailedNotification = _c[1];
    var openModal = useModal();
    var drawerRef = useRef(null);
    var t = useTranslation().t;
    var activeMenuItem = useAppSelector(selectors.selectActiveMenuItem);
    var selectedIds = useAppSelector(selectors.selectSelectedIds);
    var selectedEdges = useAppSelector(selectors.selectSelectedEdges);
    var is3DLoading = useAppSelector(selectors.selectIs3DLoading);
    var isSystemDataLoading = useAppSelector(selectors.selectIsSystemDataLoading);
    var selectedNodes = useAppSelector(selectors.selectFilteredSelectedNodes);
    var selectedNodesType = useAppSelector(selectors.selectFilteredSelectedNodesType);
    var dispatch = useAppDispatch();
    var generateSceneScreenshot = usePlaycanvasApplicationContext().generateScreenshot;
    var _d = useGraphDataContext(), generateGraphScreenshot = _d.generateScreenshot, setPrintModeActive = _d.setPrintModeActive;
    var parameterGroups = useAppSelector(selectors.selectGroupedParametersDefineParameters);
    var onGenerateSceneScreenshot = function (width, height) {
        return generateSceneScreenshot(width, height);
    };
    var toggleGraphPanelInPrintMode = function (active) {
        dispatch(actions.toggleGraphPanel(active));
        setPrintModeActive(active);
    };
    var onContactUs = function () { return __awaiter(void 0, void 0, void 0, function () {
        var configurationId, configurationParam, token, tokenParam;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getConfigurationId()];
                case 1:
                    configurationId = _a.sent();
                    configurationParam = configurationId
                        ? "&".concat(loadConfigurationParameterName, "=").concat(configurationId)
                        : "";
                    token = LocalStorage.getItem(StorageKey.AUTH_TOKEN);
                    tokenParam = token ? "&token=".concat(token) : "";
                    window.open("".concat(contactFormURL).concat(configurationParam).concat(tokenParam), "_blank");
                    return [2 /*return*/];
            }
        });
    }); };
    var getConfigurationId = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var configurationId, persistParts, persistConfigs_1, persistConfigs_1_1, config, storedSlice, id, e_1;
        var e_2, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    configurationId = undefined;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    persistParts = [];
                    try {
                        for (persistConfigs_1 = __values(persistConfigs), persistConfigs_1_1 = persistConfigs_1.next(); !persistConfigs_1_1.done; persistConfigs_1_1 = persistConfigs_1.next()) {
                            config = persistConfigs_1_1.value;
                            storedSlice = window.sessionStorage.getItem("persist:".concat(config.key));
                            storedSlice &&
                                persistParts.push({ persistKey: config.key, data: storedSlice });
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (persistConfigs_1_1 && !persistConfigs_1_1.done && (_a = persistConfigs_1.return)) _a.call(persistConfigs_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                    return [4 /*yield*/, dispatch(actions.saveConfiguration({
                            persistParts: persistParts,
                        })).unwrap()];
                case 2:
                    id = (_b.sent()).id;
                    configurationId = id;
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _b.sent();
                    console.error("Could not create system link", e_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, configurationId];
            }
        });
    }); }, [dispatch]);
    var onOpenSummaryModal = function () {
        /* Deselect entities before showing modal to avoid faded entities
         * in the screenshot. Could probably be improved in the future */
        if (selectedIds.length > 0) {
            dispatch(actions.deselectEntities);
        }
        toggleGraphPanelInPrintMode(true);
        openModal(_jsx(SummaryModal, { generateSceneScreenshot: onGenerateSceneScreenshot, generateGraphScreenshot: generateGraphScreenshot, onCloseModal: function () { return toggleGraphPanelInPrintMode(false); } }));
    };
    var onCopyLink = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var configurationId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getConfigurationId()];
                case 1:
                    configurationId = _a.sent();
                    if (!configurationId) {
                        setShowShareFailedNotification(true);
                        return [2 /*return*/];
                    }
                    navigator.clipboard.writeText(getSharableLink(configurationId));
                    setShowShareNotification(true);
                    return [2 /*return*/];
            }
        });
    }); }, [getConfigurationId]);
    var getSelectedItemMenuTitle = function () {
        if (selectedIds.length === 0 ||
            activeMenuItem !== MenuItem.SELECTED_ENTITY) {
            return "";
        }
        if (selectedNodes.length === 0) {
            return _jsx(TitleWithInfoButton, { title: t("sidebar.edit_tube.title") });
        }
        if (selectedNodesType === null) {
            return _jsx(TitleWithInfoButton, { title: t("sidebar.mixed_selection") });
        }
        switch (selectedNodesType) {
            case NodeComponentType.GRIP_POSITION:
                return _jsx(TitleWithInfoButton, { title: t("edit_grip_position.title") });
            case NodeComponentType.TUBE_CONNECTION:
                return (_jsx(TitleWithInfoButton, { title: t("sidebar.edit_tube_connection.title"), description: {
                        long: t("descriptions.sidebar.edit_tube_connection.title"),
                    } }));
            case NodeComponentType.CENTRALIZED_VACUUM_PUMP: {
                return _jsx(TitleWithInfoButton, { title: t("sidebar.edit_pump.title") });
            }
            case NodeComponentType.FEED_PRESSURE_POINT:
                return (_jsx(TitleWithInfoButton, { title: t("sidebar.edit_feed_pressure_point.title") }));
            default:
                return "";
        }
    };
    var getSelectedItemComponent = function () {
        if (activeMenuItem !== MenuItem.SELECTED_ENTITY)
            return null;
        if (selectedIds.length === 0)
            return null;
        // both nodes and edges are selected
        if (selectedNodes.length && selectedEdges.length) {
            return _jsx(MixedSelectionMenu, { nodes: selectedNodes, edges: selectedEdges });
        }
        // only edges of the same type are selected
        if (!selectedNodes.length &&
            selectedEdges.length &&
            selectedEdges.every(function (edge) { return edge.tubeType === selectedEdges[0].tubeType; })) {
            return _jsx(EdgeMenu, { edges: selectedEdges });
        }
        // only nodes are selected, check if they are of the same type
        switch (selectedNodesType) {
            case NodeComponentType.GRIP_POSITION:
                return _jsx(GripPositionMenu, { nodes: selectedNodes });
            case NodeComponentType.TUBE_CONNECTION:
                return _jsx(TubeConnectionMenu, { nodes: selectedNodes });
            case NodeComponentType.CENTRALIZED_VACUUM_PUMP: {
                return _jsx(CentralizedVacuumPumpMenu, { nodes: selectedNodes });
            }
            case NodeComponentType.FEED_PRESSURE_POINT: {
                // Assumption: only one feed pressure point can exist in a system
                return _jsx(FeedPressurePointMenu, { node: selectedNodes[0] });
            }
            default: {
                return (_jsx(MixedSelectionMenu, { nodes: selectedNodes, edges: selectedEdges }));
            }
        }
    };
    var sidebarWidth = (_a = drawerRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth;
    return (_jsxs(Styled.SidebarPanel, { ref: drawerRef, children: [_jsx(DeveloperTicket, {}), _jsx(Styled.LogoContainer, { children: _jsx(Logo, {}) }), _jsx(SystemTypeSwitch, {}), _jsx(Toolbar, {}), _jsxs(CustomTreeNav, { label: t("sidebar.title"), className: "".concat(Styled.prefix, "-top-tree-nav"), activeItem: activeMenuItem, onActiveItemChange: function (itemId) {
                    return dispatch(actions.openMenuItem(itemId));
                }, children: [_jsx(DefaultGroupMenu, { sidebarWidth: sidebarWidth, parameterGroups: parameterGroups, activeMenuItem: activeMenuItem }), _jsx(SidebarDrawerButton, { sidebarWidth: sidebarWidth ? sidebarWidth : 0, title: t("sidebar.application"), id: "application", button: _jsx(TreeNavItem, { id: "application", label: t("sidebar.application") }), customRenderElement: _jsx(ApplicationMenu, {}) }), _jsx(TreeNavItem, { className: "".concat(Styled.prefix, "-hidden-tree-nav-item"), id: "application_speed", label: t("dashboard.application_speed"), children: _jsx(ApplicationSpeedMenu, {}) }), _jsx(TreeNavItem, { className: "".concat(Styled.prefix, "-hidden-tree-nav-item"), id: MenuItem.SELECTED_ENTITY, label: getSelectedItemMenuTitle(), children: getSelectedItemComponent() })] }), _jsx(GoogleAnalyticsElement, { event: googleAnalyticsEvents.click.contactUs, children: _jsx(Button, { className: "".concat(Styled.prefix, "-sidebar-button"), onClick: onContactUs, children: t("sidebar.contact_us") }) }), _jsx(GoogleAnalyticsElement, { event: googleAnalyticsEvents.click.summaryOrder, children: _jsx(Button, { className: "".concat(Styled.prefix, "-sidebar-button"), onClick: onOpenSummaryModal, children: t("sidebar.summary_button") }) }), _jsx(GoogleAnalyticsElement, { event: googleAnalyticsEvents.click.copyLink, children: _jsx(Button, { className: "".concat(Styled.prefix, "-sidebar-button"), appearance: "inverted", onClick: onCopyLink, icon: "copy", children: t("sidebar.share_button") }) }), showShareNotification && (_jsx(TimedNotification, { text: t("notifications.link_copied"), timeout: 3000, color: "success", onClose: function () { return setShowShareNotification(false); } })), showShareFailedNotification && (_jsx(TimedNotification, { text: t("notifications.link_copy_error"), timeout: 3000, color: "alert", onClose: function () { return setShowShareFailedNotification(false); } })), _jsx(DelayedFallback, { isLoading: isSystemDataLoading || is3DLoading, fallback: _jsx(LoadingOverlay, {}), delay: 200 })] }));
};
